import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const continueButton = {
    height: pxToRem(40),
    paddingTop: [pxToRem(12)],
    paddingBottom: [pxToRem(12)],
    paddingLeft: [pxToRem(20)],
    paddingRight: [pxToRem(20)],
    color: 'white',
    backgroundColor: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: [pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)],
    fontWeight: 700,
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    borderRadius: 0,
    margin: `0 !important`,
    '&:hover': {
        color: 'cav_red',
        backgroundColor: 'white',
        border: `${pxToRem(1)} solid`
    },
    '&:disabled': {
        backgroundColor: 'cav_red',
        '&:hover': {
            color: 'white',
            backgroundColor: 'cav_red'
        }
    }
}

export const orSignInTextStyle = {
    align: 'center',
    fontFamily: fonts.primary,
    fontSize: {base: 'sm', lg: 'md'},
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    fontStyle: 'normal',
    bg: 'white',
    px: pxToRem(10),
    mt: '0 !important'
}

export const socialMediaLoginStyle = {
    button: {
        borderRadius: 'none',
        borderColor: 'cav_red',
        mt: {base: `${pxToRem(10)} !important`, lg: `${pxToRem(15)} !important`},
        fontSize: {base: 'xs', lg: 'sm'},
        color: 'cav_red',
        fontWeight: 'bold',
        fontStyle: 'normal',
        lineHeight: pxToRem(13.5),
        letterSpacing: pxToRem(1.5),
        textTransform: 'uppercase'
    }
}

export const loginFieldsStyle = {
    '.password-container': {
        mt: {base: `${pxToRem(57)} !important`, lg: `${pxToRem(80)} !important`}
    },
    '.email-entered': {
        mt: '0 !important',
        fontSize: {base: pxToRem(14), lg: pxToRem(16)},
        fontFamily: fonts.primary,
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        span: {
            ml: pxToRem(10),
            fontSize: {base: pxToRem(10), lg: pxToRem(12)},
            fontWeight: 'medium',
            color: 'cav_red',
            textDecoration: 'underline',
            textTransform: 'uppercase',
            cursor: 'pointer'
        }
    }
}
